// Add your custom JS here.
import Carousel from 'bootstrap/js/dist/carousel'


/* START Scroll Effects
 * Taken from: https://css-tricks.com/styling-based-on-scroll-position/
 */
if (
  'IntersectionObserver' in window &&
  'IntersectionObserverEntry' in window &&
  'intersectionRatio' in window.IntersectionObserverEntry.prototype
) {
  let observer = new IntersectionObserver(entries => {
    if (entries[0].boundingClientRect.y < 0) {
      document.body.classList.add('header-out-of-view');
    } else {
      document.body.classList.remove('header-out-of-view');
    }
  });
  observer.observe(document.querySelector("#header-pixel-anchor"));
}
/* END Scroll Effects */

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

jQuery( document ).ready( function( $ ) {

  /* START Close Menu On Click */
  $("#main-menu a:not(.dropdown-toggle)").click(function(){
    $("#navbarNavDropdown").removeClass("show");
  });
  /* End Close Menu On Click */

  /* START Hero Carousel */
  function initCarousel(theCarousel) {
    var carousel = new Carousel(theCarousel, {
      ride:     'carousel',
      pause:    false,
      interval: 5000
    });
    $(theCarousel).find(".carousel-item").first().find("video").first().trigger('play');


    $(theCarousel).on('slid.bs.carousel', function(ev) {
      let slides = $(this).find(".carousel-item");
      let pvid = slides[ev.from].querySelectorAll('video')[0];
      if(pvid != null) {
        pvid.pause();
        pvid.currentTime = 0;
      }
      let vid = slides[ev.to].querySelectorAll('video')[0];
      if(vid != null) {
        vid.play();
      }
    });

/*
    $(theCarousel).find("video").on('play', function (e) {
        $(theCarousel).carousel('pause');
    });
    $(theCarousel).find("video").on('ended', function (e) {
        $(theCarousel).carousel('next');
        $(theCarousel).carousel('cycle');
    });
*/
  }

  const carouselHeroTop = document.getElementById('carouselHeroTop');
  if(carouselHeroTop) {
    initCarousel(carouselHeroTop);
  }

  /* End Hero Carousel */

  $(".grid-3-card").click(function(){
    $(this).find(".grid-3-card-inner").focus();
  });

  $(".flex-3-card").click(function(){
    $(this).find(".flex-3-card-inner").focus();
  });

});
